// extracted by mini-css-extract-plugin
export var actionButton = "_kp-0";
export var fileInput = "_kp-2";
export var paperclip = "_kp-1";